import { Compass, Sparkles } from 'lucide-react';
import { Button, Card } from '@/features/common/ui';
import { WELCOME_TOUR_ID } from './tours';
import { useAvailableTours, useTourRun, useTourState } from './TourHost';

/**
 * Settings' way back into the tours - the same list as the ? button, for the
 * person who looks for help where the settings are.
 */
export function ToursCard() {
  const tours = useAvailableTours();
  const { state } = useTourState();
  const start = useTourRun((s) => s.start);
  if (!tours.length) return null;
  return (
    <Card className="p-4" data-testid="tours-card">
      <h2 className="text-sm font-semibold">Guided tours</h2>
      <p className="mt-0.5 text-xs text-muted-foreground">
        Take any of them again, as often as you like. New features come with a short one of their own.
      </p>
      <ul className="mt-3 divide-y divide-border">
        {tours.map(({ tour, steps }) => {
          const Icon = tour.id === WELCOME_TOUR_ID ? Compass : Sparkles;
          const taken = state?.tours[tour.id];
          return (
            <li key={tour.id} className="flex items-center gap-3 py-2">
              <Icon className="size-4 shrink-0 text-primary" aria-hidden />
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium">{tour.id === WELCOME_TOUR_ID ? 'The Fint tour' : tour.title}</p>
                <p className="text-xs text-muted-foreground">
                  {steps} step{steps === 1 ? '' : 's'}
                  {taken ? ` · ${taken.status === 'done' ? 'taken' : 'skipped'} ${new Date(taken.at).toLocaleDateString('en-IN')}` : ''}
                </p>
              </div>
              <Button size="sm" variant="outline" onClick={() => start(tour.id)}>
                {taken?.status === 'done' ? 'Take again' : 'Start'}
              </Button>
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
